// Читаем window.__ENV__.API_BASE — он генерится entrypoint-скриптом в env.js
// при старте контейнера из runtime env-переменной. См. docker-entrypoint.sh.
declare global { interface Window { __ENV__?: { API_BASE?: string } } }
const BASE: string = (window.__ENV__ && window.__ENV__.API_BASE)
  || "http://localhost:8080";
const TOKEN_KEY = "altuwka_admin_session";

export function getToken(): string | null { return localStorage.getItem(TOKEN_KEY); }
export function setToken(t: string | null): void {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

async function call<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = getToken();
  const r = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  let data: any = null;
  try { data = await r.json(); } catch {}
  if (!r.ok) {
    const err: any = new Error(data?.error || `HTTP ${r.status}`);
    err.code = data?.code; err.status = r.status;
    throw err;
  }
  return data as T;
}

export const api = {
  authInit: () => call<{ state: string; login_url: string }>("POST", "/api/auth/init"),
  authCheck: (state: string) => call<any>("GET", `/api/auth/check?state=${encodeURIComponent(state)}`),

  health: () => call<any>("GET", "/api/admin/health"),
  summary: () => call<any>("GET", "/api/admin/summary"),
  daily: (days = 14) => call<{ daily: any[] }>("GET", `/api/admin/stats/daily?days=${days}`),
  usage: (days = 30) => call<{ usage: any[] }>("GET", `/api/admin/stats/usage?days=${days}`),

  users: (skip = 0, limit = 50, q = "") =>
    call<{ total: number; users: any[] }>(
      "GET", `/api/admin/users?skip=${skip}&limit=${limit}${q ? `&q=${encodeURIComponent(q)}` : ""}`,
    ),
  grantCredits: (uid: number, delta: number) =>
    call<any>("POST", `/api/admin/users/${uid}/credits`, { delta }),
  setPremium: (uid: number, premium: boolean) =>
    call<any>("POST", `/api/admin/users/${uid}/premium`, { premium }),

  chats: (skip = 0, limit = 50, type?: string) =>
    call<{ total: number; chats: any[] }>(
      "GET", `/api/admin/chats?skip=${skip}&limit=${limit}${type ? `&type=${type}` : ""}`,
    ),
  chatLimits: (chatId: number, body: { per_user_daily?: number; per_chat_daily?: number }) =>
    call<any>("PATCH", `/api/admin/chats/${chatId}/limits`, body),

  payments: (skip = 0, limit = 50) =>
    call<{ total: number; payments: any[] }>("GET", `/api/admin/payments?skip=${skip}&limit=${limit}`),

  // ---- subscriptions tiers ----
  tiers: () => call<{ tiers: any[]; free_mcp_limits: { daily_credits: number; cost_per_request_credits: number; window_seconds: number }; credit_to_usd: number }>("GET", "/api/admin/sub/tiers"),
  createTier: (body: any) => call<any>("POST", "/api/admin/sub/tiers", body),
  patchTier: (tierId: string, body: any) =>
    call<any>("PATCH", `/api/admin/sub/tiers/${encodeURIComponent(tierId)}`, body),

  patchFreeMcpLimits: (body: { daily_credits: number }) =>
    call<any>("PATCH", "/api/admin/mcp/free-limits", body),
  // ---- partners ----
  partners: () => call<{ partners: any[] }>("GET", "/api/admin/partners"),
  createPartner: (body: any) =>
    call<{ ok: boolean; token: string; name: string; balance_usd: number }>(
      "POST", "/api/admin/partners", body),
  revokePartner: (token: string) =>
    call<any>("DELETE", `/api/admin/partners/${encodeURIComponent(token)}`),
  topupPartner: (token: string, delta: number) =>
    call<any>("POST", `/api/admin/partners/${encodeURIComponent(token)}/balance`, { delta_usd: delta }),
  partnerStats: (token: string, days = 30) =>
    call<any>("GET", `/api/admin/partners/${encodeURIComponent(token)}/stats?days=${days}`),
  // ---- userbot ----
  userbotSummary: () => call<any>("GET", "/api/admin/userbot/summary"),
  userbotSettings: () => call<{ settings: any }>("GET", "/api/admin/userbot/settings"),
  updateUserbotSettings: (body: any) => call<any>("PATCH", "/api/admin/userbot/settings", body),
  userbotChats: (skip = 0, limit = 100, q = "", type = "", enabled = "") =>
    call<{ total: number; chats: any[] }>(
      "GET",
      `/api/admin/userbot/chats?skip=${skip}&limit=${limit}${q ? `&q=${encodeURIComponent(q)}` : ""}${type ? `&type=${encodeURIComponent(type)}` : ""}${enabled ? `&enabled=${encodeURIComponent(enabled)}` : ""}`,
    ),
  updateUserbotChat: (chatId: number, body: any) =>
    call<any>("PATCH", `/api/admin/userbot/chats/${chatId}`, body),
  resetUserbotUsage: (chatId: number) =>
    call<any>("POST", `/api/admin/userbot/chats/${chatId}/reset_usage`),
};
